import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchProUsers(action) {
  try {
    const { proType, search, page, pageSize } = action.payload || {};

    let url = `/pro-management/list_users/?`;
    if (proType && proType !== 'all') url += `pro_type=${proType}&`;
    if (search) url += `search=${encodeURIComponent(search)}&`;
    if (page) url += `page=${page}&`;
    if (pageSize) url += `page_size=${pageSize}&`;

    const result = yield call(AxiosCall, url);
    yield put(actions.fetchProUsersSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchProUsersFailure(e.message || e));
  }
}

function* fetchProStats() {
  try {
    const result = yield call(AxiosCall, `/pro-management/stats/`);
    yield put(actions.fetchProStatsSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchProStatsFailure(e.message || e));
  }
}

function* grantComplimentaryPro(action) {
  try {
    const { userId, reason, expiresDays } = action.payload;
    const payload = {
      user_id: userId,
      reason: reason || '',
    };
    if (expiresDays) {
      payload.expires_days = expiresDays;
    }

    const result = yield call(AxiosPost, `/pro-management/grant/`, payload);
    yield put(actions.grantComplimentaryProSuccess(result.data));

    // Refresh the list and stats after granting
    yield put(actions.fetchProUsersRequest());
    yield put(actions.fetchProStatsRequest());
  } catch (e) {
    yield put(actions.grantComplimentaryProFailure(e.message || e));
  }
}

function* revokeComplimentaryPro(action) {
  try {
    const { userId } = action.payload;
    const payload = { user_id: userId };

    const result = yield call(AxiosPost, `/pro-management/revoke/`, payload);
    yield put(actions.revokeComplimentaryProSuccess(result.data));

    // Refresh the list and stats after revoking
    yield put(actions.fetchProUsersRequest());
    yield put(actions.fetchProStatsRequest());
  } catch (e) {
    yield put(actions.revokeComplimentaryProFailure(e.message || e));
  }
}

function* bulkGrantComplimentaryPro(action) {
  try {
    const { userIds, reason, expiresDays } = action.payload;
    const payload = {
      user_ids: userIds,
      reason: reason || '',
    };
    if (expiresDays) {
      payload.expires_days = expiresDays;
    }

    const result = yield call(AxiosPost, `/pro-management/bulk_grant/`, payload);
    yield put(actions.bulkGrantComplimentaryProSuccess(result.data));

    // Refresh the list and stats after bulk granting
    yield put(actions.fetchProUsersRequest());
    yield put(actions.fetchProStatsRequest());
  } catch (e) {
    yield put(actions.bulkGrantComplimentaryProFailure(e.message || e));
  }
}

export default function* proManagementSaga() {
  yield all([
    takeLatest(actions.FETCH_PRO_USERS.REQUEST, fetchProUsers),
    takeLatest(actions.FETCH_PRO_STATS.REQUEST, fetchProStats),
    takeLatest(actions.GRANT_COMPLIMENTARY_PRO.REQUEST, grantComplimentaryPro),
    takeLatest(actions.REVOKE_COMPLIMENTARY_PRO.REQUEST, revokeComplimentaryPro),
    takeLatest(actions.BULK_GRANT_COMPLIMENTARY_PRO.REQUEST, bulkGrantComplimentaryPro),
  ]);
}
